import { createSelector } from 'reselect'
import { SHIPPING_CODES_FOR_FREE_SHIPPING } from 'modules/shipping/constants'
import { getSelectedMethodShippingUtil } from 'modules/shipping/utils/get-selected-method'
import updateReduxUtil from 'modules/redux/utils/update'
import { SHIPPING_MODEL_KEY } from 'models/daos/shipping/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { isEligibleForFreeShippingCartSelector } from 'modules/cart/selectors/is-eligible-for-free-shipping'

function getSelectedMethodShippingSelector () {
  return createSelector(
    state => getSelectedMethodShippingUtil(state),
    isEligibleForFreeShippingCartSelector(),
    (shippingMethod, isEligibleForFreeShipping) => {
      if (!shippingMethod) {
        return
      }
      if (
        isEligibleForFreeShipping &&
        SHIPPING_CODES_FOR_FREE_SHIPPING.includes(
          getValueReduxUtil(shippingMethod, SHIPPING_MODEL_KEY.CODE)
        )
      ) {
        return updateReduxUtil(shippingMethod, {
          [SHIPPING_MODEL_KEY.LOCAL_IS_FREE]: true
        })
      }
      return shippingMethod
    }
  )
}

function getSelectedMethodCodeShippingSelector () {
  return createSelector(
    getSelectedMethodShippingSelector(),
    (shippingMethod) => (
      getValueReduxUtil(shippingMethod, SHIPPING_MODEL_KEY.CODE) || ''
    )
  )
}

export {
  getSelectedMethodShippingSelector,
  getSelectedMethodCodeShippingSelector
}
